import { AuthTypes, ContentType } from 'enums';

function getAuthTypesFromBroadcasts(broadcasts = []) {
    const authTypes = [];
    if (broadcasts.length > 0) {
        if (['espn_dtc', 'bam_dtc', 'espn_ppv'].indexOf(broadcasts[0].adobeResource) !== -1) {
            authTypes.push(AuthTypes.BAM);
        } else {
            authTypes.push(AuthTypes.MVPD);
        }
        if (broadcasts[0].ipAuth === true) {
            authTypes.push(AuthTypes.ISP);
        }
    }
    return authTypes;
}

function getPackagesFromBroadcasts(broadcasts = []) {
    let packages = [];
    if (broadcasts.length > 0 && broadcasts[0].packages) {
        packages = broadcasts[0].packages;
    }
    return packages;
}

function getSourceTypeFromBroadcasts(broadcasts = []) {
    let sourceType;
    if (broadcasts.length > 0) {
        sourceType = broadcasts[0].type;
    }
    return sourceType;
}

function getSourceIdFromBroadcasts(broadcasts = []) {
    let sourceId;
    if (broadcasts.length > 0) {
        sourceId = broadcasts[0].code;
    }
    return sourceId;
}

function getSourceFromBroadcasts(broadcasts = []) {
    let source;
    if (broadcasts.length > 0) {
        source = broadcasts[0].shortName;
    }
    return source;
}

function getAdobeResourceFromBroadcasts(broadcasts = []) {
    let adobeResource;
    if (broadcasts.length > 0) {
        adobeResource = broadcasts[0].adobeResource;
    }
    return adobeResource;
}

function getImageHrefFromBroadcasts(thumbnails = {}) {
    let imageHref;
    if (thumbnails.large) {
        imageHref = thumbnails.large.href;
    }
    return imageHref;
}

/**
 * Takes a listing from the v1 api and converts it to a content item
 */
// TODO: DTC - make sure this works for both 5.x and 6.x app
export default function getContentFromListing(listing = {}) {
    return {
        id: listing.id.toString(),
        type: ContentType.LISTING,
        name: listing.name,
        status: listing.type,
        imageHref: getImageHrefFromBroadcasts(listing.thumbnails),
        backgroundImageHref: listing.backgroundImageHref,
        streams: [{
            id: listing.id.toString(),
            status: listing.type,
            name: listing.name,
            source: {
                id: getSourceIdFromBroadcasts(listing.broadcasts),
                name: getSourceFromBroadcasts(listing.broadcasts),
                type: getSourceTypeFromBroadcasts(listing.broadcasts)
            },
            authTypes: getAuthTypesFromBroadcasts(listing.broadcasts),
            adobeResource: getAdobeResourceFromBroadcasts(listing.broadcasts),
            packages: getPackagesFromBroadcasts(listing.broadcasts)
        }]
    };
};

export function getV1ContentFromListing(listing = {}) {
    return {
        id: listing.id,
        type: ContentType.EVENT,
        name: listing.name,
        status: listing.type,
        source: getSourceFromBroadcasts(listing.broadcasts),
        sourceId: getSourceIdFromBroadcasts(listing.broadcasts),
        sourceType: getSourceTypeFromBroadcasts(listing.broadcasts),
        authTypes: getAuthTypesFromBroadcasts(listing.broadcasts),
        packages: getPackagesFromBroadcasts(listing.broadcasts),
        imageHref: getImageHrefFromBroadcasts(listing.thumbnails)
    };
};



// WEBPACK FOOTER //
// ./app/lib/format/getContentFromListing.js